//
import { baseUrl } from "@/common/ev";
const transformDefault = {
  timeout: 30e3,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
  },
  xhrFields: {
    withCredentials: true
  }
};

export function handleOptions(options) {
  let ev = options.ev || "common";
  let ops = { ...transformDefault, baseURL: baseUrl[ev] };
  localStorage.Authorization && (ops.headers.Authorization = localStorage.Authorization);
  return ops;
}
